// tslint:disable:max-line-length

import * as React from "react";
import {ReactNode} from "react";
import TranslateNew from "@translate/TranslateNew";
import {WithStyles, withStyles} from "@material-ui/core";
import {AIStyle} from "./ai.style";
import Carousel from "../../carousel/carousel.component";
import Button from '@components/common/button/Button';

const tn: TranslateNew = TranslateNew.getInstance();

interface ICarouselProps extends WithStyles<typeof AIStyle> {
  close: () => void;
}

class AIOnboarding extends React.Component<ICarouselProps> {

  constructor(props: any) {
    super(props);
  }

  public render() {
    const {classes, close} = this.props;

    const slides:JSX.Element [] = [
      <div key="1" className={this.props.classes.slide}>
        <div className={this.props.classes.title}>{tn.lang.aiOnboardingSlide1Title}</div>
        <div className={this.props.classes.text}>{tn.lang.aiOnboardingSlide1Text}</div>
      </div>,
      <div key="2" className={this.props.classes.slide}>
        <img src={'aiimage.png'} style={{ width: '80%'}} alt="Arrow" />
        <div className={this.props.classes.title}>{tn.lang.aiOnboardingSlide2Title}</div>
        <div className={this.props.classes.text}>{tn.lang.aiOnboardingSlide2Text}</div>
      </div>,
      <div key="3" className={this.props.classes.slide}>
        <img src={'aianalys.png'} style={{ width: '80%'}} alt="Arrow" />
        <div className={this.props.classes.title}>{tn.lang.aiOnboardingSlide3Title}</div>
        <div className={this.props.classes.text}>{tn.lang.aiOnboardingSlide3Text}</div>
      </div>,
      <div key="4" className={this.props.classes.slide}>
        <div className={this.props.classes.title}>{tn.lang.aiOnboardingSlide4Title}</div>
        <div className={this.props.classes.text}>{tn.lang.aiOnboardingSlide4Text}</div>
        <Button variant="contained" size="large" onClick={() => close()} color="primary" style={{marginTop:'60px'}}
          classes={{contained:classes.buttonContainedLarge}} >
          {tn.lang.aiOnboardingSlide4Button}
        </Button>
      </div>];

    return (
      <Carousel close={close} slides={slides}/>
    );
  }
}



export default withStyles(AIStyle)(AIOnboarding);



// WEBPACK FOOTER //
// ./src/components/calendar2/fab/AIOnboarding.component.tsx